(function(){
/* GraceYears — preview dong cho SKU #6 Family Tree (1a Watercolor · 1e Deep Roots · 1d Leaf Wreath)
   Chien luoc: B ROI RAC — dem so ten -> chon BAC -> chon file nen + bang toa do. Trong mot bac chi CHU CHAY, khong tinh layout.
   Toa do lay tu "Family Tree Wall Art.dc.html" (Claude Design, 11/08/2026). % so voi khung file 3300x4200. font-size = % chieu rong W. */
var CDN='https://cdn.shopify.com/s/files/1/0770/8167/3883/files/';
var BG={a13:CDN+'gy-bg-1a-b1b3.jpg',a4:CDN+'gy-bg-1a-b4.jpg',e:CDN+'gy-bg-1e.jpg',d:CDN+'gy-bg-1d.jpg'};
var COL={fam:'#43533A',g1:'#4A3A2C',g2:'#2F3A28',g3:'#33372C',g4:'#5A4A3B',anc:'#63513F',est:'#7A6450',paper:'#FBF7EF',pill:'#7E9370'};

/* ---- BANG TOA DO ---- */
var L={
 a:{ bg:BG.a13, bg4:BG.a4,
   base:{fam:[5,81.0,90,9.4,12.00],est:[6,91.4,88,3.0,3.09],g1:[14,69.5,72,5.5,4.55]},
   B1:{max:10, g2:[5,44.0,90,7.0,4.18], g3:[6,25.0,88,8.0,3.82]},
   B2:{max:20, g2:[5,44.0,90,7.0,3.64], g3:[5,20.0,90,15.0,3.27]},
   B3:{max:35, g2:[5,44.0,90,7.0,3.27], g3:[4,17.5,92,22.0,2.91], g4:[11,11.0,78,4.5,2.55]},
   B4:{max:60, fam:[5,3.5,90,6.9,8.73], est:[6,12.5,88,2.6,2.55], g1:[18,48.5,64,4.6,3.82],
       colHead:[6,58.0,16,3.0,2.55], colBody:[6,61.5,16,27.5,2.36], colStep:17.2, cols:5, g4:[6,91.5,88,3.5,2.18]}},
 e:{ bg:BG.e, max:26,
   base:{g3:[5,13.0,90,15.0,2.73],g2:[8,33.0,84,12.0,3.09],fam:[10,48.4,80,7.6,9.64],
         g1:[18,66.0,64,4.8,3.64],anc:[8,80.0,84,7.0,2.73],est:[6,91.5,88,2.6,2.36]}, famPaper:true},
 d:{ bg:BG.d, max:18,
   base:{fam:[20,45.5,60,5.6,7.09],g1:[22,54.5,56,2.9,2.73],est:[22,60.5,56,2.2,2.18]},
   ring:{g2:{r:24.5,ang:[0,72,144,216,288],fs:2.36},g3:{r:33.5,ang:[22.5,67.5,112.5,157.5,202.5,247.5,292.5,337.5],fs:2.36}}}
};

var css='#gy-tree{margin:16px 0 4px}'
+'#gy-tree .cap{margin:0 0 8px;font-weight:600;font-size:16px}'
+'#gy-tree .frame{max-width:340px;padding:10px;background:#fff;border:1px solid #e6ded2;border-radius:10px;box-shadow:0 6px 22px rgba(0,0,0,.10)}'
+'#gy-tree .art{position:relative;width:100%;aspect-ratio:.7857;overflow:hidden;background:'+COL.paper+' center/cover no-repeat;font-family:Montserrat,system-ui,sans-serif}'
+'#gy-tree .ly{position:absolute;display:flex;align-items:center;justify-content:center;text-align:center;line-height:1.18}'
+'#gy-tree .wrap{flex-wrap:wrap;align-content:center;gap:.28em .34em}'
+'#gy-tree .chip{font-family:Montserrat,system-ui,sans-serif!important;display:inline-block;padding:.16em .55em;border-radius:999px;background:rgba(251,247,239,.93);border:1px solid '+COL.pill+';white-space:nowrap;font-weight:500}'
+'#gy-tree .fam,#gy-tree .fam *{font-family:Parisienne,cursive!important;white-space:nowrap;color:'+COL.fam+'}'
+'#gy-tree .fampaper{background:'+COL.paper+';padding:0 .18em;border-radius:4px}'
+'#gy-tree .est,#gy-tree .est *{font-family:"Cormorant Garamond",Georgia,serif!important;letter-spacing:.34em;text-transform:uppercase;color:'+COL.est+';white-space:nowrap}'
+'#gy-tree .anc,#gy-tree .anc *{font-family:"Cormorant Garamond",Georgia,serif!important;letter-spacing:.22em;text-transform:uppercase;color:'+COL.anc+'}'
+'#gy-tree .ringwrap{position:absolute;left:50%;top:50%;width:0;height:0}'
+'#gy-tree .ringwrap span{font-family:Montserrat,system-ui,sans-serif!important;position:absolute;left:0;top:0;white-space:nowrap;color:'+COL.g3+'}'
+'#gy-tree .meas{position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0}'
+'#gy-tree .note{margin:8px 0 0;font-size:14px;opacity:.75;max-width:340px}'
+'#gy-tree .tier{margin:6px 0 0;font-size:13px;color:#5A4A3B}';
var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);
if(!document.querySelector('link[href*="Parisienne"]')){var lk=document.createElement('link');lk.rel='stylesheet';
 lk.href='https://fonts.googleapis.com/css2?family=Parisienne&family=Cormorant+Garamond:wght@600&family=Montserrat:wght@500;600&display=swap';document.head.appendChild(lk);}

/* nhan dien concept tu tieu de */
var h1=document.querySelector('h1');var tl=(h1?h1.textContent:'').toLowerCase();
var KEY = tl.indexOf('wreath')>=0 ? 'd' : (tl.indexOf('ancestor')>=0||tl.indexOf('roots')>=0) ? 'e' : 'a';

function esc(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;');}
function val(n){var el=document.querySelector('[name="properties['+n+']"]');return el?el.value.trim():'';}
function lines(n){return val(n).split(/\r?\n/).map(function(x){return x.trim();}).filter(function(x){return x.length;});}
var host,art,meas;
function wpx(t,ls,fam){meas.style.letterSpacing=(ls||0)+'em';meas.style.fontFamily=fam||'Montserrat,sans-serif';meas.style.fontSize='100px';meas.textContent=t;return (meas.getBoundingClientRect().width||1)/100;}

function box(spec,W,H,cls,html,extra){
 var d=document.createElement('div');d.className='ly '+(cls||'');
 d.style.left=spec[0]+'%';d.style.top=spec[1]+'%';d.style.width=spec[2]+'%';d.style.height=spec[3]+'%';
 d.style.fontSize=(W*spec[4]/100).toFixed(2)+'px';
 if(extra)for(var k in extra)d.style[k]=extra[k];
 d.innerHTML=html;return d;
}
function chips(arr,color){return arr.map(function(x){return '<span class="chip" style="color:'+color+'">'+esc(x)+'</span>';}).join('');}

function draw(){
 if(!art)return;
 var W=art.clientWidth||320,H=W/0.7857;
 var fam=val('Family name')||'The Millers';
 var est=val('Est year');
 var g1=lines('Grandparents'), g2=lines('Children'), g3=lines('Grandchildren'), g4=lines('Great-grandchildren'), anc=lines('Ancestors');
 if(!g1.length&&!g2.length&&!g3.length){g1=['Robert & Mary'];g2=['David & Anna','Sarah & Tom'];g3=['Emma','Noah','Ava','Liam','Kai'];}
 var total=g1.length+g2.length+g3.length+g4.length;
 art.innerHTML='<span class="meas"></span>';meas=art.querySelector('.meas');
 var cfg=L[KEY],b,bgUrl=cfg.bg,tierTxt='';

 if(KEY==='a'){
   b = total<=10?cfg.B1 : total<=20?cfg.B2 : total<=35?cfg.B3 : cfg.B4;
   tierTxt = total<=10?'B1 · up to 10 names':total<=20?'B2 · 11–20 names':total<=35?'B3 · 21–35 names':'B4 · 36–60 names';
   if(b===cfg.B4){
     bgUrl=cfg.bg4;
     art.appendChild(box(b.fam,W,H,'fam','<span>'+esc(fam)+'</span>'));
     if(est)art.appendChild(box(b.est,W,H,'est','EST. '+esc(est)));
     art.appendChild(box(b.g1,W,H,'wrap',chips(g1,COL.g1)));
     var per=Math.ceil(g3.length/b.cols)||1;
     for(var c=0;c<b.cols;c++){
       var head=g2[c]||'';var seg=g3.slice(c*per,(c+1)*per);
       if(!head&&!seg.length)continue;
       art.appendChild(box([b.colHead[0]+c*b.colStep,b.colHead[1],b.colHead[2],b.colHead[3],b.colHead[4]],W,H,'',
         '<span class="anc" style="font-size:1em">'+esc(head)+'</span>'));
       art.appendChild(box([b.colBody[0]+c*b.colStep,b.colBody[1],b.colBody[2],b.colBody[3],b.colBody[4]],W,H,'wrap',
         seg.map(function(x){return '<div style="width:100%;color:'+COL.g3+'">'+esc(x)+'</div>';}).join(''),{alignContent:'flex-start',flexDirection:'column',justifyContent:'flex-start'}));
     }
     if(g4.length)art.appendChild(box(b.g4,W,H,'wrap',g4.map(function(x){return '<span style="color:'+COL.g4+';margin:0 .5em">'+esc(x)+'</span>';}).join('')));
   } else {
     art.appendChild(box(cfg.base.fam,W,H,'fam','<span>'+esc(fam)+'</span>'));
     if(est)art.appendChild(box(cfg.base.est,W,H,'est','EST. '+esc(est)));
     art.appendChild(box(cfg.base.g1,W,H,'wrap',chips(g1,COL.g1)));
     art.appendChild(box(b.g2,W,H,'wrap',chips(g2,COL.g2)));
     art.appendChild(box(b.g3,W,H,'wrap',chips(g3,COL.g3)));
     if(b.g4&&g4.length)art.appendChild(box(b.g4,W,H,'wrap',chips(g4,COL.g4)));
   }
 } else if(KEY==='e'){
   var B=cfg.base;
   tierTxt = total<=20?'up to 20 names':'21–26 names';
   art.appendChild(box(B.g3,W,H,'wrap',chips(g3,COL.g3)));
   art.appendChild(box(B.g2,W,H,'wrap',chips(g2,COL.g2)));
   art.appendChild(box(B.fam,W,H,'fam','<span class="fampaper">'+esc(fam)+'</span>'));
   art.appendChild(box(B.g1,W,H,'wrap',chips(g1,COL.g1)));
   if(anc.length)art.appendChild(box(B.anc,W,H,'wrap anc',anc.map(function(x){return '<span style="margin:0 .55em">'+esc(x)+'</span>';}).join('')));
   if(est)art.appendChild(box(B.est,W,H,'est','ROOTED SINCE '+esc(est)));
 } else {
   var Bd=cfg.base;
   tierTxt='up to 18 names';
   art.appendChild(box(Bd.fam,W,H,'fam','<span>'+esc(fam)+'</span>'));
   art.appendChild(box(Bd.g1,W,H,'wrap',chips(g1,COL.g1)));
   if(est)art.appendChild(box(Bd.est,W,H,'est','EST. '+esc(est)));
   var rw=document.createElement('div');rw.className='ringwrap';
   [['g2',g2],['g3',g3]].forEach(function(pair){
     var spec=cfg.ring[pair[0]],arr=pair[1];
     arr.slice(0,spec.ang.length).forEach(function(nm,i){
       var R=W*spec.r/100,A=spec.ang[i];
       var s=document.createElement('span');
       s.style.fontSize=(W*spec.fs/100).toFixed(2)+'px';
       s.style.color=(pair[0]==='g2'?COL.g2:COL.g3);
       s.style.transform='translate(-50%,-50%) rotate('+A+'deg) translateY(-'+R.toFixed(1)+'px) rotate(-'+A+'deg)';
       s.textContent=nm;rw.appendChild(s);
     });
   });
   art.appendChild(rw);
 }
 art.style.backgroundImage='url('+bgUrl+')';
 /* co chu ho gia dinh cho vua be ngang */
 var fe=art.querySelector('.fam');
 if(fe){var inner=fe.firstElementChild||fe;var maxW=W*(KEY==='a'?0.86:KEY==='e'?0.76:0.56);
   var w1=wpx(fam,0,'Parisienne,cursive')*parseFloat(fe.style.fontSize);
   if(w1>maxW)fe.style.fontSize=(parseFloat(fe.style.fontSize)*maxW/w1).toFixed(2)+'px';}
 var tv=document.getElementById('gy-tree-tier');
 if(tv)tv.textContent=total+' names · layout '+tierTxt;
 var over=(KEY==='a'&&total>60)||(KEY==='e'&&total>26)||(KEY==='d'&&total>18);
 if(tv)tv.style.color=over?'#A33':'#5A4A3B';
 if(over&&tv)tv.textContent=total+' names — more than this design holds ('+cfg.max+'). Remove a few, or choose another style below.';
}

function bind(){
 host=document.getElementById('gy-tree');
 var f=document.querySelector('[name="properties[Family name]"]');
 if(!host||!f)return setTimeout(bind,600);
 host.innerHTML='<p class="cap">Your print, as you type</p><div class="frame"><div class="art"><span class="meas"></span></div></div>'
  +'<p class="tier" id="gy-tree-tier"></p>'
  +'<p class="note">This shows your names, their order and where they sit. The paper and finish are shown in the photos above.</p>';
 art=host.querySelector('.art');meas=host.querySelector('.meas');
 ['Family name','Est year','Grandparents','Children','Grandchildren','Great-grandchildren','Ancestors'].forEach(function(n){
   var el=document.querySelector('[name="properties['+n+']"]');
   if(el)el.addEventListener('input',draw);
 });
 window.addEventListener('resize',draw);
 if(document.fonts&&document.fonts.ready)document.fonts.ready.then(draw);
 draw();setTimeout(draw,900);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
})();
